import { Typography } from "@mui/material"
import { Inputlabel, FormInput } from "gf-ui-components-mui-lib"
import styles from "../../organisms/generateClient/styles.module.scss"

export const ClientForm = ({
  clientFormData,
  setClientFormData,
}: {
  clientFormData: {
    clientOrderNum: string
    clientName: string
    address: string
    notes: string
  }
  setClientFormData: React.Dispatch<
    React.SetStateAction<{
      clientOrderNum: string
      clientName: string
      address: string
      notes: string
    }>
  >
}) => {
  const labelStyle = {
    color: "#344054",
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "20px",
    paddingTop: "24px",
  }
  const updateFormData = (e: any) => {
    const { name, value } = e.target
    const newObj = {
      ...clientFormData,
      [name]: value,
    }

    setClientFormData(newObj)
  }
  return (
    <div className={`${styles.clientFormContainer}`}>
      <Typography
        sx={{
          ...labelStyle,
          fontSize: "16px",
          fontWeight: 600,
          lineHeight: "24px",
          textTransform: "uppercase",
          textAlign: "center",
          borderBottom: "1px solid var(--gray-200, #EAECF0)",
          background: "var(--gray-25, #FCFCFD)",
          padding: "12px",
        }}
      >
        Please complete the following instructions
      </Typography>
      <div className={`${styles.clientForm}`}>
        <Inputlabel label="Client Order No. *" sx={labelStyle} />
        <FormInput
          name={"clientOrderNum"}
          onChange={updateFormData}
          placeholder="Input"
          value={clientFormData?.clientOrderNum ?? ""}
          sx={{ paddingTop: "8px" }}
        />
        <Inputlabel label="Client Name *" sx={labelStyle} />
        <FormInput
          name={"clientName"}
          onChange={updateFormData}
          placeholder="Input"
          value={clientFormData?.clientName ?? ""}
          sx={{ paddingTop: "8px" }}
        />
        <Inputlabel label="Address" sx={labelStyle} />
        <FormInput
          name={"address"}
          onChange={updateFormData}
          placeholder="Input"
          value={clientFormData?.address ?? ""}
          sx={{ paddingTop: "8px" }}
        />
        <Inputlabel label="Notes" sx={labelStyle} />
        <FormInput
          name={"notes"}
          onChange={updateFormData}
          placeholder="Input"
          value={clientFormData?.notes ?? ""}
          sx={{ paddingTop: "8px" }}
        />
      </div>
    </div>
  )
}
